import type { InventoryProductRow } from "./inventoryProducts";

export interface CategoryChip {
  id: string;
  label: string;
  count: number;
}

/**
 * G-132 — the quick-filter chips for the busiest categories: products per
 * category, most first, ties broken by label so the row does not reshuffle
 * between refreshes.
 */
export function topCategories(products: InventoryProductRow[], n = 4): CategoryChip[] {
  const byId = new Map<string, CategoryChip>();
  for (const { item } of products) {
    const found = byId.get(item.category.id);
    if (found) found.count += 1;
    else byId.set(item.category.id, { id: item.category.id, label: item.category.label, count: 1 });
  }
  return [...byId.values()]
    .sort((a, b) => b.count - a.count || a.label.localeCompare(b.label, undefined, { sensitivity: "base" }))
    .slice(0, n);
}
